/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import Input from '../../forms/Input';
import formatPhone, { formatPhoneToNumber } from '~h/format-phone';

import * as validators from '~h/validators';
import InputPhone from '~c/ui/InputPhone';
import Contacts from '~/components/Contacts';
import messages from '~h/messages';

// Metrika
import metrikaId from '~/helpers/metrika';
import metrikaGoal from '~/helpers/metrikaGoal';

// Routing
import routes from '~/apiRouter';
import PopupClose from '../Close';

class CuratorMessage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      messageText: '',
      name: window.user?.FIRST_NAME || '',
      sername: window.user?.LAST_NAME || '',
      phoneNumber: formatPhone(window.user?.TELEPHONE || ''),
      email: window.user?.EMAIL || '',

      status: '',
      loading: '',
      managerId: '',
      isSernameValid: true,
      isNameValid: true,
      isEmailValid: true,
      isMessageTextValid: true,
      ContactInfo: '',
      errorMessage: '',
    };
  }

  componentDidMount() {
    metrikaGoal('feedback-open-popup');
  }

  preflightCheck = () => {
    // 'couse of setState is async function, we need to copy it and check params of copy
    const newState = Object.assign({}, this.state);
    newState.isSernameValid = validators.checkName(newState.sername);
    newState.isNameValid = validators.checkName(newState.name);
    newState.isEmailValid = validators.checkEmail(newState.email);
    newState.isMessageTextValid = validators.checkNotEmpty(
      newState.messageText,
    );
    this.setState(newState);

    if (
      newState.isNameValid &&
      newState.isSernameValid &&
      newState.isEmailValid
    ) {
      return true;
    }

    return false;
  };

  changeManager(managerNewId) {
    const { managerId } = this.state;
    if (managerId !== managerNewId) {
      this.setState({ managerId: managerNewId });
    }
  }

  sendData() {
    // add validate if is not loading
    const { page, manager } = this.props;
    const { managerId, loading } = this.state;

    if (!loading && this.preflightCheck() && this.state.messageText !== '') {
      this.setState({
        loading: true,
      });

      const headers = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'content-type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          EMAIL: this.state.email,
          NAME: this.state.name,
          TEXT: this.state.messageText,
          SURNAME: this.state.sername,
          PHONE: formatPhoneToNumber(this.state.phoneNumber),
        }),
      };

      const fetchUrl = manager ? `${routes.designer.manager}${manager}/notify` : `${routes.designer.get}${page}/manager/${managerId}/notify/`;

      fetch(fetchUrl, headers)
        .then(response => response.json())
        .then(response => {
          // check if ok or not ok
          if (response.status === 'success') {
            metrikaGoal('feedback-send');
            this.setState({ loading: false, status: 'success' });
          }

          if (response.status === 'error') {
            this.setState({
              errorMessage: response.errors[0],
            });
          }
        })
        .catch(error => {
          // check errors
          this.setState({
            errorMessage: messages.unknownError,
          });
        });
    }
  }

  render() {
    const { page, city, manager } = this.props;
    const {
      messageText,
      name,
      sername,
      phoneNumber,
      email,
      status,
      isMessageTextValid,
    } = this.state;

    if (status === 'success') {
      return (
        <div className="popup popup-message ">
          <div className="popup__close-container"><PopupClose/></div>
          <div className="popup-message__content popup-message__succes ">
            <h1 className="heading heading--2">Сообщение успешно отправлено</h1>
            <button
              onClick={() => $.magnificPopup.close()}
              type="button"
              className="btn btn--primary"
            >
              Закрыть
            </button>
          </div>
        </div>
      );
    }
    const textFieldStr = `popup-message__text ${
      !this.state.isMessageTextValid ? 'popup-message__text--err ' : ''
    }`;
    const nameClassStr = `inp__field ${
      !this.state.isNameValid ? 'inp__field--error' : ''
    }`;
    const serNameClassStr = `inp__field ${
      !this.state.isSernameValid ? 'inp__field--error' : ''
    }`;
    const emailClassStr = `inp__field ${
      !this.state.isEmailValid ? 'inp__field--error' : ''
    }`;
    return (
      <div className="popup popup-message-container">
        <div className="popup__close-container close_message"><PopupClose/></div>
        <div className="popup popup-message curator-message">
          <div className="popup-message__content">
            <h1 className="heading heading--2">{ manager ? 'Сообщение' : 'Сообщение куратору'}</h1>
            <div className="popup-message__text-wrap">
              <textarea
                className={textFieldStr}
                value={messageText}
                placeholder=""
                onBlur={e => {
                  const trimmed = e.target.value.trim();
                  this.setState({
                    messageText: trimmed,
                    isMessageTextValid: validators.checkNotEmpty(trimmed),
                  });
                }}
                onChange={e => {
                  this.setState({ messageText: e.target.value });
                }}
                rows="10"
              >
                {/* {messageText} */}
              </textarea>
              <label>Текст сообщения</label>
            </div>
            <div className="popup-message__inp-wrap">
              <div className="popup-message__inp">
                <Input
                  classes={serNameClassStr}
                  value={sername}
                  onChange={e => this.setState({ sername: e })}
                  label="Фамилия"
                  onBlur={e => {
                    this.setState({
                      sername: e.trim(),
                      isSernameValid: validators.checkName(e.trim()),
                    });
                  }}
                />
              </div>
              <div className=" popup-message__inp">
                <Input
                  classes={nameClassStr}
                  value={name}
                  onChange={e => this.setState({ name: e })}
                  label="Имя"
                  onBlur={e => {
                    this.setState({
                      name: e.trim(),
                      isNameValid: validators.checkName(e.trim()),
                    });
                  }}
                />
              </div>
              <div className="popup-message__inp">
                <InputPhone
                  value={this.state.phoneNumber}
                  data-valid
                  onChange={value => {
                    this.setState({ phoneNumber: value });
                  }}
                  placeholder=""
                >
                  <p className="inp__label">Телефон</p>
                </InputPhone>
              </div>
              <div className=" popup-message__inp">
                <Input
                  classes={emailClassStr}
                  value={email}
                  onChange={e => {
                    this.setState({ email: e });
                  }}
                  label="Эл. почта"
                  onBlur={e => {
                    this.setState({
                      email: e.trim(),
                      isEmailValid: validators.checkEmail(e.trim()),
                    });
                  }}
                />
              </div>
            </div>
          </div>
          <Contacts
            inPopup
            page={page}
            manager={manager}
            currentCity={city}
            onChange={managerId => this.changeManager(managerId)}
            onSubmit={() => this.sendData()}
          />
        </div>
      </div>
    );
  }
}

export default CuratorMessage;
